export const ZURICH_TZ = 'Europe/Zurich';
export const OTHER_COMPANY_ID = 12607199;
export const OTHER_PROJECT_ID = 12606712;
export const ESG_RISK_SOURCE_SYSTEM = 'ESG Risk';
export const DEFAULT_DATE_TIME_FORMAT = 'yyyy-MM-dd HH:mm:ss';
export const DEFAULT_DATE_FORMAT = 'yyyy-MM-dd';
